import useAuthStore from "../stores/useAuthStore";
import useReferenceStore from "../stores/useReferenceStore";

/**
 * Determine if a transaction is inter-state based on customer address vs store location.
 * Extracted from useOrderProcessing.getIsInterState for reuse in printers and tax breakup.
 *
 * @param {Object} cart - Cart/order object with customer.metaData
 * @returns {boolean}
 */
export function getIsInterState(cart) {
  try {
    const tillData = useAuthStore.getState().tillData;
    const storeStateId = tillData?.tillAccess?.csBunit?.csRegionId || "";
    if (!storeStateId) return false;

    const customerConfigs = useReferenceStore.getState().customerConfigs;
    const customerConfigData = customerConfigs?.[0]?.configuration ? JSON.parse(customerConfigs[0].configuration) : {};
    const fieldGroups = customerConfigData?.fieldGroups || [];
    if (!fieldGroups.length) return false;

    const storedB2B = localStorage.getItem("isB2bEnabled") === "true";
    const groupName = storedB2B ? "Delivery Address" : "Address";
    const groupId = fieldGroups.find((g) => g.name === groupName)?.id;
    if (!groupId) return false;

    const metaRow = cart?.customer?.metaData?.find((item) => item.key === groupId);
    if (!metaRow?.value) return false;

    const parsed = typeof metaRow.value === "string" ? JSON.parse(metaRow.value) : metaRow.value;
    let customerStateId = parsed?.state || "";

    const statesData = useReferenceStore.getState().statesData;
    if (customerStateId) {
      const isId = statesData.some((s) => s.RecordID === customerStateId);
      if (!isId) {
        const match = statesData.find((s) => s.Name?.toLowerCase() === customerStateId?.toLowerCase());
        customerStateId = match?.RecordID || "";
      }
    }

    return customerStateId && storeStateId !== customerStateId;
  } catch {
    return false;
  }
}
